// Common version of useGetAvailableRooms, used for update room type

import { useEffect, useMemo, useState } from 'react';
import { useLazyQuery } from '@apollo/client';
import { GET_AVAILABLE_ROOM_TYPES_BY_DATE_RANGE } from 'graphql/service';
import { RoomType } from 'types/commonTypes';


export type AvailableRoomsInput = {
  checkInDate: Date;
  checkOutDate: Date;
  isWheelchairAccessible: boolean;
  roomQuantity: number;
  guestQuantity: number;
};

const debug = false;

export const useGetAvailableRoomsByInput = (input: AvailableRoomsInput | null) => {


  const [noAvailableRooms, setNoAvailableRooms] = useState(false);

  const [run, { data, loading, error }] = useLazyQuery(
    GET_AVAILABLE_ROOM_TYPES_BY_DATE_RANGE,
    {
      notifyOnNetworkStatusChange: true,
      onCompleted: (d) => {
        const list: RoomType[] = d?.availableRoomTypesByDateRange ?? [];
        setNoAvailableRooms(list.length === 0);
      },
      onError: (e) => console.log(e.message),
    }
  );

  if (debug) {
    console.log ("[useGetAvailableRoomsByInput] - input", input);
  }

  const hasInput = Boolean(input);
  const checkInDate = input?.checkInDate;
  const checkOutDate = input?.checkOutDate;
  const isWheelchairAccessible = input?.isWheelchairAccessible;
  const roomQuantity = input?.roomQuantity;
  const guestQuantity = input?.guestQuantity;

  const stableInput = useMemo(() => {
    if (!hasInput) return null;
    
    return {
      checkInDate,
      checkOutDate,
      isWheelchairAccessible,
      roomQuantity,
      guestQuantity,
    };
  }, [
    hasInput,
    checkInDate,
    checkOutDate,
    isWheelchairAccessible,
    roomQuantity,
    guestQuantity,
  ]);

  useEffect(() => {
    if (!stableInput) return;
    run({ variables: { input: stableInput } });
  }, [stableInput, run]);

  const searchResult: RoomType[] = data?.availableRoomTypesByDateRange ?? [];

  if (debug) {
    console.log ("[useGetAvailableRoomsByInput] searchResult - ", searchResult);
  }

  return {
    searchResult,
    noAvailableRooms,
    loading,
    error,
    refetch: () => stableInput && run({ variables: { input: stableInput } }),
  };
};